export function yearsListDropdown() {
  const currentYear = new Date().getFullYear();
  const yearOptionArray: { [key: string]: string } = {};
  for (let earliestYear = 2018; earliestYear <= currentYear; earliestYear++) {
    yearOptionArray[String(earliestYear)] = String(earliestYear);
  }
  return yearOptionArray;
}
